import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import ScrollProgress from './components/ScrollProgress';
import BackToTop from './components/BackToTop';
import WhatsAppFloat from './components/WhatsAppFloat';
import { useLanguage } from './LanguageContext';
import './App.css';

function App() {
	const { locale } = useLanguage();

	return (
		<div
			className="app"
			dir={locale === 'fa' ? 'rtl' : 'ltr'}
		>
			<ScrollProgress />
			<Header />
			<main
				style={{
					background: 'rgba(255, 251, 242, 1)',
				}}
			>
				<Outlet />
			</main>
			<Footer />
			<WhatsAppFloat />
			<BackToTop />
			<ToastContainer />
		</div>
	);
}

export default App;
